import { hasStoredPasskey } from "thirdweb/wallets/in-app";
import { BaseInAppWallet } from "./BaseInAppWallet";
import { IThirdWebWallet } from "./IThirdWebWallet";
import { ThirdwebClient } from "thirdweb";
import { Web3Config } from "../../config/Web3Config";
import { ILogger } from "../../../cityversetycoon/logger/ILogger";
import { ThirdWebAnalytic } from "../../utils/ThirdWebAnalytic";

interface PasskeyConnectOptions {
    isNewPasskeyFlow: boolean;
}

export class PasskeyWallet extends BaseInAppWallet<PasskeyConnectOptions> implements IThirdWebWallet<PasskeyConnectOptions> {

    public get email(): string {
        return null;
    }

    public constructor(client: ThirdwebClient, web3Config: Web3Config, thirdWebAnalytic: ThirdWebAnalytic, logger: ILogger) {
        super(client, web3Config, thirdWebAnalytic, logger, ["passkey"]);
    }

    public async sendPasskeyLoginRequest(isNewPasskeyFlow?: boolean): Promise<void> {
        await this.connect({ isNewPasskeyFlow });
    }

    public async hasPasskey(): Promise<boolean> {
        return await this.hasStoredPasskey();
    }

    public async connect(options: PasskeyConnectOptions): Promise<boolean> {
        try {
            await this.createEmbededAccount(options.isNewPasskeyFlow);
            this.connectDefaultSmartAccount();
            this.connectEthL1SmartAccount();

            if (this.connected) {
                await Promise.all([this.updateUSDCBalance(), this.updateMONBalance()]);
                this.thirdWebAnalytic.trackConnectionEvent("connect");
            }
            return this.connected;
        } catch (e: any) {
            this.logger.debug(`Third web error caught: ${e?.message ?? e}`);
            throw e;
        }
    }

    public async autoConnect(): Promise<boolean> {
        try {
            this.embededAccount = await this.wrapOperation(() => this.embededWallet.autoConnect({
                client: this.client,
                chain: this.web3Config.targetChain,
            }), "auto connect passkey wallet");
            this.connectDefaultSmartAccount(true);
            this.connectEthL1SmartAccount(true);
            if (this.connected) {
                await Promise.all([this.updateUSDCBalance(), this.updateMONBalance()]);
                this.thirdWebAnalytic.trackConnectionEvent("auto-connect");
            }
            return this.connected;
        } catch (e: unknown) {
            this.logger.error(`[PasskeyWallet] Exception on auto connect wallet: `, e);
            return false;
        }
    }


    private async createEmbededAccount(isNewPasskeyFlow: boolean): Promise<boolean> {
        if (this.embededAccount != null) {
            this.logger.debug("No wallet found for embedded");
            return true;
        }

        const hasPasskey = await this.hasStoredPasskey();

        this.embededAccount = await this.wrapOperation(() => this.embededWallet.connect({
            client: this.client,
            strategy: "passkey",
            type: hasPasskey ? "sign-in" : isNewPasskeyFlow ? "sign-up" : "sign-in",
            chain: this.web3Config.targetChain,
            passkeyName: `cityverse-tycoon-${new Date().toISOString()}`,
        }), "connect embeded wallet");
        return this.embededAccount != null;
    }

    private async hasStoredPasskey(): Promise<boolean> {
        return await this.wrapOperation(() => hasStoredPasskey(this.client), "has stored passkey");
    }
}
